import { StaffMealStateTypes, StaffMealActionTypes } from "./StaffMeal.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: StaffMealStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const StaffMealReducer = (
  state: StaffMealStateTypes = INITIAL_STATE,
  action: any
): StaffMealStateTypes => {
  switch (action.type) {
    case StaffMealActionTypes.FETCH_ALL_STAFF_MEAL:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case StaffMealActionTypes.FETCH_ALL_STAFF_MEAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StaffMealActionTypes.FETCH_ALL_STAFF_MEAL_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StaffMealActionTypes.FETCH_ALL_STAFF_MEAL_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case StaffMealActionTypes.FETCH_ONE_STAFF_MEAL:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case StaffMealActionTypes.FETCH_ONE_STAFF_MEAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StaffMealActionTypes.FETCH_ONE_STAFF_MEAL_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StaffMealActionTypes.FETCH_ONE_STAFF_MEAL_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default StaffMealReducer;
